import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_BASE || '/api';

export default function TagsPage() {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const controller = new AbortController();
    async function load() {
      try {
        const res = await fetch(`${API_BASE}/tags?limit=50`, {
          credentials: 'include',
          signal: controller.signal,
        });
        if (!res.ok) throw new Error('fetch failed');
        const data = await res.json();
        setTags(Array.isArray(data) ? data : []);
      } catch (err) {
        if (err.name !== 'AbortError') {
          setError('Unable to load tags right now.');
        }
      } finally {
        setLoading(false);
      }
    }
    load();
    return () => controller.abort();
  }, []);

  const maxCount = tags.length > 0 ? tags[0].polls_count : 1;

  return (
    <main className="mx-auto w-full max-w-xl px-4 pb-10 pt-5">
      <h1 className="text-2xl font-semibold tracking-tight text-white">Browse by tag</h1>
      <p className="mt-1 text-sm text-voto-muted">Top tags from the archive</p>

      {loading && <p className="mt-8 text-voto-muted">Loading tags…</p>}
      {!loading && error && (
        <p className="mt-8 rounded-lg bg-voto-coral/10 p-3 text-voto-coral">{error}</p>
      )}
      {!loading && !error && tags.length === 0 && (
        <p className="mt-8 rounded-xl bg-voto-surface p-4 text-voto-muted">
          No tags yet.
        </p>
      )}
      {!loading && !error && tags.length > 0 && (
        <div className="mt-6 flex flex-wrap gap-2">
          {tags.map((tag) => {
            const scale = 0.6 + 0.9 * (tag.polls_count / maxCount);
            return (
              <Link
                key={tag.name}
                to={`/feed?tag=${encodeURIComponent(tag.name)}`}
                className="rounded-full bg-voto-surface px-3 py-1 font-medium text-voto-fg ring-1 ring-voto-line transition hover:bg-voto-raised hover:ring-voto-coral"
                style={{ fontSize: `${Math.round(scale * 14)}px` }}
                title={`${tag.polls_count} polls`}
              >
                {tag.name}
                <span className="ml-1 text-voto-muted" style={{ fontSize: '0.75em' }}>
                  {tag.polls_count}
                </span>
              </Link>
            );
          })}
        </div>
      )}
    </main>
  );
}
